/* ORBICORE: reveal Kickstarter and report Lead only on Mailchimp acceptance. */
(function () {
  'use strict';

  if (window.orbicoreSignupBound) return;
  window.orbicoreSignupBound = true;

  var accepted = false;
  var leadSent = false;

  function lead() {
    if (!accepted || leadSent || typeof window.fbq !== 'function') return;

    leadSent = true;

    try {
      window.fbq('track', 'Lead');
    } catch (_) {
      /* Tracking must not interrupt signup. */
    }
  }

  function trackKickstarterOutbound(link) {
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'KickstarterOutbound', {
          destination: 'kickstarter',
          source: 'post_signup'
        });
      }
    } catch (_) {
      /* Meta tracking must not interrupt the click. */
    }

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'kickstarter_outbound_click', {
          link_url: link.href,
          source: 'post_signup'
        });
      }
    } catch (_) {
      /* GA4 tracking must not interrupt the click. */
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-oc-kickstarter-outbound]');

    if (!link) return;

    trackKickstarterOutbound(link);
  });

  function bind() {
    document.querySelectorAll('[data-oc-signup-form]').forEach(function (form) {
      if (form.dataset.ocBound) return;

      form.dataset.ocBound = 'true';

      var busy = false;
      var status = form.parentElement.querySelector('[data-oc-signup-status]');

      function message(text) {
        status.textContent = new DOMParser()
          .parseFromString(text || '', 'text/html')
          .body.textContent;

        status.hidden = false;
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (busy || accepted || !form.reportValidity()) return;

        var trap = form.querySelector('.oc-trap input');

        if (trap && trap.value) return;

        try {
          if (typeof window.gtag === 'function') {
            window.gtag('event', 'email_subscribe_click', {
              source: 'landing_page'
            });
          }
        } catch (_) {
          /* GA4 tracking must not interrupt signup. */
        }

        busy = true;

        var button = form.querySelector('button[type="submit"]');
        button.disabled = true;

        var url = new URL(form.action);
        url.pathname = url.pathname.replace(/\/post$/, '/post-json');

        new FormData(form).forEach(function (value, key) {
          url.searchParams.set(key, value);
        });

        var callback =
          'ocSignup_' +
          Date.now() +
          '_' +
          Math.random().toString(36).slice(2);

        url.searchParams.set('c', callback);

        var script = document.createElement('script');
        var settled = false;
        var timeout;

        function finish(response) {
          if (settled) return;

          settled = true;
          clearTimeout(timeout);
          script.remove();

          window[callback] = function () {};
          busy = false;
          button.disabled = false;

          if (response && response.result === 'success') {
            accepted = true;
            status.hidden = true;

            document
              .querySelectorAll('[data-oc-signup-success]')
              .forEach(function (node) {
                node.hidden = false;
              });

            var success = form.parentElement.querySelector(
              '[data-oc-signup-success]'
            );

            document
              .querySelectorAll('[data-oc-launch-link]')
              .forEach(function (node) {
                node.href = success.querySelector('a').href;
              });

            success.focus({ preventScroll: true });

            lead();

            var attempts = 0;

            var retry = setInterval(function () {
              lead();

              if (leadSent || ++attempts >= 60) {
                clearInterval(retry);
              }
            }, 1000);
          } else {
            message(
              (response && response.msg) ||
                'Signup could not be confirmed. Please try again.'
            );
          }
        }

        window[callback] = finish;

        script.onerror = function () {
          finish(null);
        };

        timeout = setTimeout(function () {
          finish(null);
        }, 20000);

        script.src = url.toString();
        document.head.appendChild(script);
      });
    });
  }

  bind();
  document.addEventListener('shopify:section:load', bind);
}());